import React from 'react';
import { RectangleSkeleton } from '@sm360/widget-commons-general';

import './InventoryUsedTile.scss';

const InventoryUsedLoadingTile = () => (
    <div className="listing-tile-wrapper loading-used-tile">
        <div className="listing-tile" role="button" tabIndex={0}>
            <div>
                <div role="button" tabIndex={0}>
                    <div role="button" tabIndex={0} className="car-image-wrapper">
                        <RectangleSkeleton width={800} height={209} />
                    </div>
                </div>
                <div className="listing-tile-drivePowerTrains">
                    <div role="button" tabIndex={0} className="listing-tile-drivetrain">
                        <icon className="picto-showroom icon-Front-Wheel-Drive" />
                        <p>
                            <RectangleSkeleton width={30} height={15} />
                        </p>
                    </div>
                    <div role="button" tabIndex={0} className="listing-tile-transmission">
                        <icon className="picto-showroom icon-transmission" />
                        <p>
                            <RectangleSkeleton width={30} height={15} />
                        </p>
                    </div>
                    <div role="button" tabIndex={0} className="listing-tile-km">
                        <icon className="picto-showroom icon-km" />
                        <p>
                            <RectangleSkeleton width={30} height={15} />
                        </p>
                    </div>
                </div>

                <div className="listing-tiles-payment">
                    <div className="listing-tile-all-price">
                        <RectangleSkeleton width={800} height={80} />
                    </div>
                </div>
                <div className="listing-tile-footer">
                    <div className="vehicle-certification">
                        <RectangleSkeleton width={800} height={50} />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

InventoryUsedLoadingTile.displayName = 'LoadingTile-A.InventoryUsedLoadingTile';

export default InventoryUsedLoadingTile;
